import { isEmpty } from 'lodash'

import helpers from 'helpers'

const documentType = (company, clean = false) => {
  if (isEmpty(company?.document)) return ''

  if (clean) return helpers.regex.onlyNumbersAndLetters(company?.document)
  if (company?.kind === 'T') return ''
  if (company?.kind === 'P') return `CPF: ${company?.document}`
  if (company?.kind === 'C') return `CNPJ: ${company?.document}`

  return company?.document
}

export default documentType
